export const IMG = {
  heroLiving: "https://images.unsplash.com/photo-1632829882891-5047ccc421bc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  heroBedroom: "https://images.unsplash.com/photo-1549638441-b787d2e11f14?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  turnoverBed: "https://images.unsplash.com/photo-1655292912612-bb5b1bda9355?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  residentialLiving: "https://images.unsplash.com/photo-1649083048770-82e8ffd80431?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  deepKitchen: "https://images.unsplash.com/photo-1502005097973-6a7082348e28?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  kitchenAlt: "https://images.unsplash.com/photo-1565538810643-b5bdb714032a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  towels: "https://images.unsplash.com/photo-1631015108968-ba3b87f89005?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  madeBed: "https://images.unsplash.com/photo-1601276174812-63280a55656e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  livingAlt: "https://images.unsplash.com/photo-1648475236583-2e25a6cbf3bd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  hospitalityDetails: "https://images.unsplash.com/photo-1629140727571-9b5c6f6267b4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const SERVICE_AREA = "Austin, Pflugerville, Round Rock & nearby communities";
export const CONTACT_EMAIL = "masayahospitality@gmail.com";
